module.exports = __webpack_public_path__ + "img/k4.5a83e043.png";